/**
 * Punto de entrada del módulo test de cuadrantes.
 * Re-exporta el componente de pruebas de API (DatasetLoader fue eliminado en la reorganización).
 */
import React from 'react';
import ApiTesterComponent from './ApiTesterComponent';

const TestDatasetsPage = ({ currentService }) => (
  <div style={{ padding: '20px' }}>
    {currentService && (
      <p style={{ marginBottom: '16px', color: '#666' }}>
        Servicio: {currentService.nombre || currentService.id}
      </p>
    )}
    <ApiTesterComponent />
  </div>
);

export default TestDatasetsPage;
